module.exports = __webpack_public_path__ + "static/media/coffee-cup.9c4ab6b6.png";